export default {
    dashboard: 'Dashboard',
    profile: 'Profile',
    home: 'Home',
    users: 'Users',
    doctors: 'Doctors',
    patients: 'Patients',
    patient: 'Patient',
    admission: 'Admission',
    female: 'Female',
    male: 'Male',
    edit: 'Edit',
    detailsAndEdit: 'Details And Edit',
    userSettings: 'User Settings',
    persian:'Persian',
    english:'English',
    arabic:'Arabic',
    available:'Available',
    submit: 'submit',
    submitEdition: 'Submit Edition',
    login:'Login',
    logout:'Logout',
    welcomeLogin:'Welcome back, please login to your account.',
    welcomeDear: 'Welcome Dear',
    username:'Username',
    password:'Password',
    loginButton:'Login',
    add: 'Add',
    delete: 'Delete',
    active:'Active',
    inactive:'Inactive',
    deactivate:'Deactivate',
    action:'Action',
    disable: 'Disable',
    status: 'Status',
    search: 'Search',
    searchByName: 'Search By Name',
    percent: 'Percent',
    amount: 'Amount',
    tax: 'Tax',
    yes: 'Yes',
    no: 'No',
    date:'Date',
    fromDate: 'From Date',
    toDate: 'To Date',
    name:'Name',
    from: ' From ',
    to: ' To ',
    to1: ' To ',
    result: 'Result',
    positive: 'Positive',
    negative: 'Negative',
    genderDetermination: 'Gender Determination',
    forDisease: 'For Disease',
    description: 'Description',
    filters: 'Filters',
    year: 'Years',
    month: 'Months',
    day: 'Days',
    and: ',',
    registerAndNew:'Register And New',
    welcomeHomePage:'Welcome to Mom Center Management System. ',
    titleHomePage:'Fertility Center and Infertility Management System',
    confirmDelete:'Are You Sure You Want To Delete This Item/Items?',
    confirmDeleteTitle:'Confirm Delete',
    new : 'New',
    select: 'Select',
    role: 'Role',
    submitAndReferral:"Submit And Add A Referral",
    editAndReferral:"Edit And Add A Referral",
    girl: 'Girl',
    boy: 'Boy',
    noMatter: 'Girl-Boy',
    internal: 'Internal',
    external: 'External',
    pos: 'Pos',
    cash: 'Cash',
    pleaseSelect: 'Please Select',
    both: 'Both',
    print: 'Print',
    bankCard: 'Bank Card',
    recommendation: 'Recommendation',
    selectFile: 'Select File',
    image: 'Image',
    changeImage: 'Change Image',
    back: 'Back',
    present: 'Present',
    absent: 'Absent',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    one_way: 'One Way',
    two_way: 'Two Way',
    right: 'Right',
    left: 'Left',
    title:'Title',
    approved:'Approved',
    rejected:'Rejected',
    conditional:'Conditional',
    documentTitle:'Document Title',
    read:'Read',
    isRead:'Is Read',
    legalVisitTypes:{
        donated_sperm: "DONATED SPERM" ,
        donated_embryo: "DONATED EMBRYO" ,
        donated_egg: "DONATED EGG" ,
        surrogate_uterus: "SURROGATE UTERUS" ,
        egg_freeze: "EGG FREEZE" ,
        other: "OTHER" ,
        ivf: "IVF" ,
    },
    has:'Has',
    doesNotHave: 'Does Not Have',
    donationClinicAccount:"Donation Clinic Account",
    ipdAccount:"IPD Account",
    isDefault:"is Default",
    row: 'row',
    History:"تاریخچه"

}